export class User{
  constructor(
    public userName:string,
    public password:string,
    public rememberMe:boolean
  ){

  }
}



// WEBPACK FOOTER //
// ./src/models/LoginModel/User.ts